module.exports = __webpack_public_path__ + "media/vo-04-01.1cfb55e7.mp3";